import React from 'react';
import '../css/vision.css';

const VisionMission = () => {
  return (
    <section id="vision" className="vision-mission">
      <div className="container">
        <div className="vision-header">
          <h2 className="main-heading">Vision, Mission & Values</h2>
          <p className="sub-heading">Built on values, driven by purpose, committed to excellence</p>
        </div>

        <div className="fancybox-container">
          <div className="fancybox-row">
            {/* Vision Card */}
            <div className="fancybox-col fancybox-col-lg-4 fancybox-col-md-6 fancybox-col-sm-6">
              <div className="fancybox-item">
                <div className="fancybox__icon-img">
                  <img 
                    src="/vision.png" 
                    alt="Vision Icon" 
                    className="icon-image"
                  />
                </div>
                <div className="fancybox__content">
                  <h4 className="fancybox__title">Vision</h4>
                  <p className="fancybox__desc">
                    To grow with partners and stakeholders by achieving strategic goals through continuous 
                    improvement and teamwork. We strive to be the leading valve manufacturer recognized for 
                    innovation, quality, and sustainable practices.
                  </p>
                </div>
              </div>
            </div>

            {/* Mission Card */}
            <div className="fancybox-col fancybox-col-lg-4 fancybox-col-md-6 fancybox-col-sm-6">
              <div className="fancybox-item">
                <div className="fancybox__icon-img">
                  <img 
                    src="/mission.png" 
                    alt="Mission Icon" 
                    className="icon-image"
                  />
                </div>
                <div className="fancybox__content">
                  <h4 className="fancybox__title">Mission</h4>
                  <p className="fancybox__desc">
                    Driven by sustainable manufacturing, ethical business practices, and innovation. 
                    We are committed to delivering precision-engineered valve solutions that exceed 
                    customer expectations while promoting environmental protection and social responsibility.
                  </p>
                </div>
              </div>
            </div>

            {/* Values Card */}
            <div className="fancybox-col fancybox-col-lg-4 fancybox-col-md-6 fancybox-col-sm-6">
              <div className="fancybox-item">
                <div className="fancybox__icon-img">
                  <img 
                    src="/values.png" 
                    alt="Values Icon" 
                    className="icon-image"
                  />
                </div>
                <div className="fancybox__content">
                  <h4 className="fancybox__title">Values</h4>
                  <p className="fancybox__desc">
                    Aim for highest customer satisfaction - Be Caring for our stakeholders, people and our society - 
                    Be passionate for continuous innovation and high performance - Respect for safety & environment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
